import { Component, ElementRef, Renderer2, ViewChild, inject } from '@angular/core';

import { AbstractCalendarComponent } from '../../abstract-calendar.component';

@Component({
  selector: 'cam-calendar-view',
  templateUrl: './view.component.html',
  styleUrl: './view.component.scss',
})
export class CamCalendarViewComponent extends AbstractCalendarComponent {
  @ViewChild('calendar', { static: true })
  calendar!: ElementRef;

  private _renderer = inject(Renderer2);

  ngAfterViewInit() {
    this._registerSubscription(
      this.getIsReady$().subscribe({
        next: () => {
          if (this._calendar.component) {
            this._renderer.appendChild(this.calendar.nativeElement, this._calendar.component.nativeElement);
          }
        },
      })
    );
  }
}
